import { projectPath } from "../../routerPaths"

export const tryExtractProjectIdFromPath = () => {
    const pathSegments = document.location.pathname.split(projectPath)

    if (pathSegments.length > 1) {
        return pathSegments[1].split("/")[1]
    }
}
